// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"6b92b0df","868":"0c941c34"}[chunkId] + ".chunk.css";
};